import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { lastSiiMessages } from '../../../../../lib/api/dashboard';
import CenteredCircularProgress from '../../../../../lib/designSystem/CircularProgress';
import EnhancedTable from '../../../../../lib/designSystem/Table';

const SiiMessages: React.FC = () => {
  const dispatch = useDispatch();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchRelations = async () => {
      setLoading(true);
      const relations = await lastSiiMessages(dispatch);
      setInvoices(relations || []);
      setLoading(false);
    };
    void fetchRelations();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <Typography variant="h5">Notificaciones SII</Typography>
      <EnhancedTable
        dataHeaders={[
          { key: 'businessName', label: 'Cuenta' },
          { key: 'message', label: 'Mensaje' },
          { key: 'createdAt', label: 'Fecha', type: 'date' },
        ]}
        data={invoices}
        rowsPerPageDefault={5}
        completeTable
      />
    </div>
  );
};

export default SiiMessages;
